var iframeElement = null;
export var downloadFileFromUrl = function (url) {
    if (iframeElement === null) {
        iframeElement = createIframeElement();
    }
    iframeElement.src = url;
};
var createIframeElement = function () {
    var iframeElement = document.createElement('iframe');
    iframeElement.style.display = 'none';
    document.body.appendChild(iframeElement);
    return iframeElement;
};
